import create from './create';
import deleteApi from './delete';
import detail from './detail';
import edit from './edit';
import list from './list';

const ApiCall = {
  list,
  detail,
  create,
  edit,
  delete: deleteApi,
};

export default ApiCall;
